import { render, staticRenderFns } from "./orderView.vue?vue&type=template&id=12e070b3&scoped=true"
import script from "./orderView.vue?vue&type=script&lang=js"
export * from "./orderView.vue?vue&type=script&lang=js"
import style0 from "./orderView.vue?vue&type=style&index=0&id=12e070b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e070b3",
  null
  
)

export default component.exports